import { ProcessDoc } from "../Interfaces/processDocs";
import { WorkInstruction } from "../Interfaces/workInstruction";

export const workInstructionVMF = (workInstruction: WorkInstruction[], workStation: number, vehicleModel: number): WorkInstruction[] => {
    return workInstruction.filter((workInstruction) => {
        return workInstruction.work_station_id.Int64 === workStation && workInstruction.vehicle_model_id.Int64 === vehicleModel;
    });
}

export interface MergedWorkInstruction {
    id: number;
    title: string;
    description: string;
    file: string | null;
    drawing: string | null;
    video: string | null;
    instructionId: number | null;
    drawingInstructionId: number | null;
    videoInstructionId: number | null;
    drawingOwnerId: number;
    videoOwnerId: number;
}

const normalizeInstructionTitle = (title: string) => title.trim().toLowerCase();

const sortByNewestId = (instructions: WorkInstruction[]) => {
    return [...instructions].sort((a, b) => b.id - a.id);
};

export const mergeWorkInstructionRecords = (
    instructions: WorkInstruction[]
): MergedWorkInstruction[] => {
    const groupedInstructions = new Map<string, WorkInstruction[]>();

    instructions.forEach((instruction) => {
        const titleKey = normalizeInstructionTitle(instruction.title);
        const existingGroup = groupedInstructions.get(titleKey) ?? [];
        existingGroup.push(instruction);
        groupedInstructions.set(titleKey, existingGroup);
    });

    return Array.from(groupedInstructions.values())
        .map((group) => {
            const sortedGroup = sortByNewestId(group);
            const pdfRecord = sortedGroup.find((instruction) => instruction.file);
            const primaryRecord = pdfRecord ?? sortedGroup[0];
            const drawingRecord = sortedGroup.find((instruction) => instruction.drawing);
            const videoRecord = sortedGroup.find((instruction) => instruction.video);

            return {
                id: primaryRecord.id,
                title: primaryRecord.title,
                description: primaryRecord.description,
                file: pdfRecord?.file ?? null,
                drawing: drawingRecord?.drawing ?? null,
                video: videoRecord?.video ?? null,
                instructionId: pdfRecord?.id ?? null,
                drawingInstructionId: drawingRecord?.id ?? null,
                videoInstructionId: videoRecord?.id ?? null,
                drawingOwnerId: drawingRecord?.id ?? primaryRecord.id,
                videoOwnerId: videoRecord?.id ?? primaryRecord.id,
            };
        })
        .sort((a, b) => b.id - a.id);
};


export const processDocNJMH = (processDoc: ProcessDoc[], vehicle_model_id: number): ProcessDoc|undefined => {
    return processDoc.find((processDoc) => {
        return processDoc.vehicle_model_id.Int64 === vehicle_model_id;
    });
}

export const buildProcessVMF = () => {}
